import React from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaUser, FaRegEnvelope, FaRegCommentDots } from 'react-icons/fa';
import { useForm, ValidationError } from '@formspree/react';

const email = 'utkarshsrivastava746@gmail.com';
const phone = '+91-8299064081';
const location = 'New Delhi, India';

const FORMSPREE_FORM_ID = 'xldjqnwe';

const Contact = () => {
  const [state, handleSubmit] = useForm(FORMSPREE_FORM_ID);

  return (
    <div className="container section">
      <div className="row justify-content-center align-items-stretch g-5 flex-column flex-md-row">
        {/* Side Panel with Contact Info */}
        <div className="col-12 col-md-4 mb-4 mb-md-0">
          <div className="contact-info-card p-4 h-100 rounded-4 shadow-sm d-flex flex-column justify-content-center align-items-start" style={{ background: 'var(--about-card-bg, #fff)', border: '1.5px solid var(--about-border, #E0E0E0)' }}>
            <h3 className="fw-bold mb-4" style={{ color: 'var(--about-accent, #2F80ED)' }}>Contact Details</h3>
            <div className="d-flex align-items-center gap-3 mb-3">
              <FaEnvelope className="contact-icon" />
              <span>{email}</span>
            </div>
            <div className="d-flex align-items-center gap-3 mb-3">
              <FaPhoneAlt className="contact-icon" />
              <span>{phone}</span>
            </div>
            <div className="d-flex align-items-center gap-3">
              <FaMapMarkerAlt className="contact-icon" />
              <span>{location}</span>
            </div>
          </div>
        </div>
        {/* Contact Form */}
        <div className="col-12 col-md-7">
          <div className="contact-form-card p-4 rounded-4 shadow-sm" style={{ background: 'var(--about-card-bg, #fff)', border: '1.5px solid var(--about-border, #E0E0E0)' }}>
            <h2 className="fw-bold mb-4" style={{ color: 'var(--about-primary, #1C1C1C)' }}>Get in Touch</h2>
            {state.succeeded ? (
              <Alert variant="success">Thank you! Your message has been sent.</Alert>
            ) : (
              <Form onSubmit={handleSubmit} autoComplete="off">
                <Form.Group className="mb-4" controlId="formName">
                  <Form.Label className="d-flex align-items-center gap-2 fw-semibold">
                    <FaUser className="form-label-icon" /> Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    required
                    className="modern-input"
                  />
                  <ValidationError prefix="Name" field="name" errors={state.errors} />
                </Form.Group>
                <Form.Group className="mb-4" controlId="formEmail">
                  <Form.Label className="d-flex align-items-center gap-2 fw-semibold">
                    <FaRegEnvelope className="form-label-icon" /> Email
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    required
                    className="modern-input"
                  />
                  <ValidationError prefix="Email" field="email" errors={state.errors} />
                </Form.Group>
                <Form.Group className="mb-4" controlId="formMessage">
                  <Form.Label className="d-flex align-items-center gap-2 fw-semibold">
                    <FaRegCommentDots className="form-label-icon" /> Message
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    placeholder="Type your message"
                    required
                    className="modern-input"
                  />
                  <ValidationError prefix="Message" field="message" errors={state.errors} />
                </Form.Group>
                <div className="d-grid">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={state.submitting}
                    className="rounded-pill modern-submit-btn py-2 px-4 fs-5 fw-semibold"
                  >
                    Send Message
                  </Button>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
